import { Component, Inject, PACKAGE_ROOT_URL } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '../alert.service';
import { AuthService } from '../auth.service';
import { setTimeout } from 'timers';
import { AccountStatsService } from '../account-stats.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-deactivated-numbers',
  templateUrl: './deactivated-numbers.component.html',
  styleUrls: ['./deactivated-numbers.component.scss']
})

export class deactivatedNumbersComponent {

  public allApplications: Application[];
  public statsData: StatsData | null;
  public isLoading: boolean;
 
  public currentTime = new Date;
  public futureTime = new Date;
  public delay = 0;
  constructor(
    private http: HttpClient,
    private alert: AlertService,
    public accountStats: AccountStatsService,
    public auth: AuthService,
    @Inject('BASE_URL') private baseUrl: string) {

    this.allApplications = [];
    this.statsData = null;
    this.isLoading = false;

    this.displayData();
  }

  displayData(): void {
    this.http.get<Application[]>(this.baseUrl + 'api/DeactivatedNumbers/Get').subscribe(result => {
      this.allApplications = result;
      this.updateStats();
      this.dailyRefresh(7, 0, 0);
      // Defer so the overlay stays visible until Angular finishes rendering the new data
      setTimeout(() => { this.isLoading = false; }, 0);
    }, error => {
      this.alert.error(`Error getting applications`, false, 3);
      console.error(error);
      // Defer so the overlay stays visible until Angular finishes rendering the new data
      setTimeout(() => { this.isLoading = false; }, 0);
    });
  }

  attemptsButtonResponse(application: Application, index: number, isScreenPop: boolean): void {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    application.isScreenPop = isScreenPop;
    if (isScreenPop) {
      this.popScreen(application);
    }
    this.markAttempted(application);
  }

  markAttempted(application: Application): void {
    let account = this.allApplications.find(x => x.accountNumber == application.accountNumber);
    account ? account.worked = true : null;
    this.updateDatabase(application);
  }

  updateDatabase(application: Application): void {
    this.http.post(this.baseUrl + 'api/DeactivatedNumbers/Update', application).subscribe(() => {
      this.displayData();
    }, error => {
      this.alert.error("Error while updating this record", false, 3);
      console.error(error);
      this.isLoading = false;
    });
  }

  updateActive(application: Application): void {
    if (this.isLoading) {
      return;
    }

    let account = this.allApplications.find(x => x.accountNumber == application.accountNumber);
    account ? account.active = 1 : null;
    (<HTMLInputElement>document.getElementById("Active")).disabled = false;
    (<HTMLInputElement>document.getElementById("Inactive")).disabled = true;
    this.isLoading = true;
    this.http.post(this.baseUrl + 'api/DeactivatedNumbers/Active', application).subscribe(() => {    
      this.displayData();
    }, error => {
      this.alert.error("Error while updating this worklist", false, 3);
      console.error(error);
      this.isLoading = false;
    });
  }

  updateInactive(application: Application): void {
    if (this.isLoading) {
      return;
    }

    let account = this.allApplications.find(x => x.accountNumber == application.accountNumber);
    account ? account.inactive = 1 : null;
    (<HTMLInputElement>document.getElementById("Active")).disabled = true;
    (<HTMLInputElement>document.getElementById("Inactive")).disabled = false;
    this.isLoading = true;
    this.http.post(this.baseUrl + 'api/DeactivatedNumbers/Inactive', application).subscribe(() => {   
      this.displayData();
    }, error => {
      this.alert.error("Error while updating this worklist", false, 3);
      console.error(error);
      this.isLoading = false;
    });
  }

  popScreen(application: Application): void {
    this.http.post<PopScreenResult>(this.baseUrl + 'api/FiservApi/PopScreen', application).subscribe(result => {
      if (result.HasErrors === true) {
        result.Errors.forEach(error => {
          var errorToShow: string;
          if (error.Description == 'User is not logged in or inactive') {
            errorToShow = 'Please login to Flex to continue';
          } else {
            errorToShow = error.Description;
          }
          this.alert.error(errorToShow, false, 5);
        });
      } else if (!result || result.HasErrors === null) {
        this.alert.error('Error communicating with fiserv.', false, 5);
      } else {
        this.alert.success('Successful!', false, 3);
      }
    }, error => {
      this.alert.error('Error communicating with the server:' + JSON.stringify(error), false, 5);
      console.error(error);
      });
  }

  dailyRefresh(hours: number, minutes: number, seconds: number): void {
    var targetRefreshTime = new Date(); //time when this method gets called
    var localTimeForThisMethod = new Date(); //time when this method gets called

    targetRefreshTime.setDate(this.currentTime.getDate() + 1); //put target refresh time a day into the future

    targetRefreshTime.setHours(hours); //target refresh hour from method parameters
    targetRefreshTime.setMinutes(minutes); //target refresh minute from method parameters
    targetRefreshTime.setSeconds(seconds); //target refresh second from method parameters

    var timeUntilReset = (targetRefreshTime.getTime() - localTimeForThisMethod.getTime()); //determine time until next reset
    setTimeout(() => this.displayData(), Math.abs(timeUntilReset)); //call reset cache at target time. This will update next taget refresh time to next day as well
  }

  updateStats(): void {
    this.http.get<StatsData>(this.baseUrl + 'api/DeactivatedNumbers/GetStatsData').subscribe(result => {
      this.statsData = result;

      this.accountStats.DoneAccounts = this.statsData.doneToday;
      this.accountStats.WorkedToday = this.statsData.workedToday;

    }, error => {
      this.alert.error(`Error getting applications`, false, 3);
      console.error(error)
    });

    this.accountStats.TotalAccounts = this.allApplications.length;

    this.accountStats.WorkedAccounts = this.allApplications.filter(x => x.worked).length;
  }

}
class Application {
  accountNumber: string = '';
  defiAppId: number = 0;
  phoneNumber: string = '';
  deactivationDate: Date = new Date();
  loadDate: Date | null = null;
  isScreenPop: boolean = false;
  contactAttemptCount: number = 0;

  worked: boolean = false;
  active: number = 0;
  inactive: number = 0;

  isFiservSucess: boolean = false;
}

class StatsData {
  doneToday: number;
  workedToday: number;

  constructor() {
    this.doneToday = 0;
    this.workedToday = 0;
  }
}

interface PopScreenResult {
  Errors: PopScreenError[];
  HasErrors: boolean;
}

interface PopScreenError {
  Description: string;
  ErrorCode: string;
  IsBusinessError: boolean;
}



// WEBPACK FOOTER //
// ./src/app/deactivated-numbers/deactivated-numbers.component.ts